'use client'

import { FC } from 'react'
import cx from 'classnames'
import { Link } from '@/components/Link'
import { CmsCategory } from '../types'
import styles from './BlogCategory.module.scss'

export interface BlogCategoryProps {
  category: CmsCategory
  active?: boolean
  className?: string
  onClick?: () => void
  desktop?: boolean
}

export const BlogCategory: FC<BlogCategoryProps> = ({
  category,
  active = false,
  className = '',
  onClick = () => {},
}) => {
  const { title } = category.fields
  return (
    <div
      onClick={onClick}
      className={cx(styles.category, className, {
        [styles.active]: active,
      })}
    >
      {title}
    </div>
  )
}

export const BlogCategoryLink: FC<BlogCategoryProps> = ({
  category,
  className,
  active,
  onClick,
  desktop,
}) => {
  return (
    <Link
      url={`/blog/${category.fields.slug + '/'}`}
      className={cx(styles.categoryLink, className, {
        [styles.desktop]: Boolean(desktop),
      })}
      activeClassName={styles.categoryLinkActive}
    >
      <BlogCategory category={category} active={active} onClick={onClick} />
    </Link>
  )
}
